import { ELoadingState, INetworkError, TChangeStateMetadata } from '../INetworkLoader';
import { INetworkLoadStats } from './NetworkLoadStats';

export enum ENetworkLoadFetchNetworkEvent {
  // ingoing
  FETCH = 'fetch',
  ABORT = 'abort',
  DESTROY = 'destroy',

  // outgoing
  DATA_READY = 'dataReady',
  STATS_READY = 'statsReady',
  CHANGE_STATE = 'changeState',
  ERROR = 'error',
  REDIRECT_DETECTED = 'redirectDetected',
}

export type TNetworkLoadFetchNetworkEventPayload =
  | {
      type: ENetworkLoadFetchNetworkEvent.FETCH;
      payload: { url: string; mode: 'text' | 'arrayBuffer'; requestCustomReferer?: string };
    }
  | {
      type: ENetworkLoadFetchNetworkEvent.ABORT;
      payload: { url: string };
    }
  | {
      type: ENetworkLoadFetchNetworkEvent.DESTROY;
      payload: { url: string };
    }
  | {
      type: ENetworkLoadFetchNetworkEvent.DATA_READY;
      payload: { url: string; binaryData: ArrayBuffer };
    }
  | {
      type: ENetworkLoadFetchNetworkEvent.STATS_READY;
      payload: { url: string; stats: INetworkLoadStats };
    }
  | {
      type: ENetworkLoadFetchNetworkEvent.ERROR;
      payload: { url: string; error: INetworkError };
    }
  | {
      type: ENetworkLoadFetchNetworkEvent.REDIRECT_DETECTED;
      payload: { url: string; responseUrl: string };
    }
  | {
      type: ENetworkLoadFetchNetworkEvent.CHANGE_STATE;
      payload: { url: string; newState: ELoadingState; metadata: TChangeStateMetadata };
    };
